import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { getAccountListData, getAccountOverviewData } from './mockData'
import type { IAccount, IAccountOverview } from '~/types/account/models'

interface GetAccountsResponse {
  data: IAccount[]
}

async function getAccounts(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  console.log(`'Returning accounts.`)
  const responseBody: GetAccountsResponse = { data: await getAccountListData() }
  return res(ctx.status(200), ctx.json(responseBody))
}

interface GetAccountOverviewResponse {
  data: IAccountOverview
}

const getAccountOverview = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  try {
    const responseBody: GetAccountOverviewResponse = {
      data: await getAccountOverviewData(id)!, // will either be valid or will have thrown error
    }
    return res(ctx.status(200), ctx.json(responseBody))
  } catch (e) {
    const responseBody = {
      statusCode: 404,
      message: `Unable to retrieve account overview for '${id}'`,
    }
    return res(ctx.status(404), ctx.json(responseBody))
  }
}

// post

const postAccount = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getAccountListData)
}

const patchAccount = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getAccountListData)
}

const deleteAccount = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getAccountListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/accounts',
    handler: getAccounts,
  },
  {
    method: 'get',
    path: '/api/accounts/:id/overview',
    handler: getAccountOverview,
  },
  {
    method: 'post',
    path: '/api/accounts',
    handler: postAccount,
  },
  {
    method: 'patch',
    path: '/api/accounts/:id',
    handler: patchAccount,
  },
  {
    method: 'delete',
    path: '/api/accounts/:id',
    handler: deleteAccount,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
